import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setPorkPigletSourcing, setPorkPigletSourcingAdmin } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PORK_PIGLET_SOURCING } from "consts";

import { FootprintingPorkPigletSourcingPayload } from "models";

export const useMutateFootprintingPorkPigletSourcing = (
  farmId: string,
  year: number,
  payload: FootprintingPorkPigletSourcingPayload,
  primaryDataId: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_PORK_PIGLET_SOURCING, primaryDataId, isAdmin],
    mutationFn: () => (isAdmin ? setPorkPigletSourcingAdmin(payload, primaryDataId) : setPorkPigletSourcing(payload, primaryDataId)),
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_PORK_PIGLET_SOURCING, primaryDataId, isAdmin],
        ...footprintingPorkPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
